import { render } from "./HeaderSection.vue?vue&type=template&id=0564b470&scoped=true"
import script from "./HeaderSection.vue?vue&type=script&lang=js"
export * from "./HeaderSection.vue?vue&type=script&lang=js"

import "./HeaderSection.vue?vue&type=style&index=0&id=0564b470&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0564b470"]])

export default __exports__